import styled from 'styled-components';

export const CenterAlignedDiv = styled.div`
    text-align: center;
`;

export const headerOffset = '152px';
